import React, { useRef } from 'react';
import styled from 'styled-components';
import Functions from '@client/style/Functions';
import { Breakpoints } from '@client/style/Variables';
import WaveContainer from './Dividers/WaveContainer';
import ModuleSwitcherCore, { Module } from '@client/core/ModuleSwitcherCore';
import BackgroundImageModule from './BackgroundImageModule';
import BackgroundVideoModule from './BackgroundVideoModule';
import { useSurroundingColors } from './shared/UseSurroundingColors';

const StyledMediaWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100vh;

	display: flex;
	flex-direction: column;
	align-items: center;

	${Functions.breakpoint(Breakpoints.tablet)} {
		height: auto;
		aspect-ratio: 16/9;
	}
`;

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
`;

const StyledBackground = styled.div<{ $bg?: string }>`
	position: absolute;
	left: 0;
	right: 0;
	height: 50%;
	background-color: ${props => props.$bg};
`;

export default function FullBleedMediaModule(props: {
	data: {
		media: [any];
	};
}) {
	const moduleRef = useRef<HTMLDivElement>(null);
	const backgroundColors = useSurroundingColors(moduleRef);

	return (
		<StyledContainer ref={moduleRef}>
			<StyledBackground $bg={backgroundColors[0]} style={{ top: 0 }} />
			<StyledBackground $bg={backgroundColors[1]} style={{ bottom: 0 }} />
			<WaveContainer side='both'>
				<StyledMediaWrapper>
					<ModuleSwitcherCore modules={props.data.media}>
						<Module modelId={'fullBleedMediaImage'} component={BackgroundImageModule} />
						<Module modelId={'fullBleedMediaLoopingVideo'} component={BackgroundVideoModule} />
					</ModuleSwitcherCore>
				</StyledMediaWrapper>
			</WaveContainer>
		</StyledContainer>
	);
}
